import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&": {
    color: theme.palette.primary.main,
    height: "100%",
    aspectRatio: "1",
  },
  "& .outline-icon, & .filled-icon": {
    transition: "opacity 250ms",
    position: "absolute",
  },
  "& .outline-icon": {
    opacity: 1,
    visibility: "visible",
  },
  "& .filled-icon": {
    opacity: 0,
    visibility: "hidden",
  },
  "&:hover": {
    background: "transparent",
    "& .outline-icon": {
      opacity: 0,
      visibility: "hidden",
    },
    "& .filled-icon": {
      opacity: 1,
      visibility: "visible",
    },
  },
}));
